(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vibaro-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vibaro-product')) {
    customElements.define('vibaro-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.data = JSON.parse(
          this.querySelector('[data-vp-data]').textContent
        );

        this.colorIndex = Number(this.dataset.colorIndex);

        this.variant =
          this.data.variants.find(v => v.id === this.data.initial) ||
          this.data.variants[0];

        this.selection = [...this.variant.options];
        this.form = this.querySelector('.vp-form');
        this.select = this.form.querySelector('[name="id"]');
        this.quantity = this.form.querySelector('[name="quantity"]');
        this.main = this.querySelector('.vp-main-image');
        this.thumbs = this.querySelector('.vp-thumbnails');
        this.guide = this.querySelector('.vp-guide');

        this.track = document.createElement('div');
        this.track.className = 'vp-track';

        if (this.main) this.track.append(this.main);

        this.querySelector('.vp-stage').prepend(this.track);

        this.track.addEventListener('scroll', () => {
          const width = this.track.clientWidth;
          if (width && this.visibleImages?.length) {
            this.markImage(Math.round(this.track.scrollLeft / width));
          }
        }, { passive: true });

        this.indexImages();
        this.paintSwatches();

        this.querySelector('.vp-native-selector').hidden = true;
        this.querySelector('.vp-options').hidden = false;

        this.addEventListener('click', event => this.onClick(event));

        this.quantity.addEventListener('change', () => {
          this.normalizeQuantity();
        });

        this.select.addEventListener('change', () => {
          const variant = this.data.variants.find(
            v => String(v.id) === this.select.value
          );

          if (variant) {
            this.selection = [...variant.options];
            this.updateVariant(false);
          }
        });

        this.form.addEventListener('submit', event => {
          this.normalizeQuantity();

          if (!this.variant?.available || !this.quantity.checkValidity()) {
            event.preventDefault();
            this.quantity.reportValidity();
          }
        });

        this.querySelector('.vp-stage').addEventListener('keydown', event => {
          if (event.target !== event.currentTarget) return;

          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showImage(
              this.imageIndex + (event.key === 'ArrowRight' ? 1 : -1)
            );
          }
        });

        this.querySelector('.vp-tablist').addEventListener('keydown', event => {
          const tabs = [...this.querySelectorAll('[role="tab"]')];
          let next = tabs.indexOf(event.target);

          if (next < 0) return;

          if (event.key === 'ArrowRight') next++;
          else if (event.key === 'ArrowLeft') next--;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;

          event.preventDefault();

          const tab = tabs[(next + tabs.length) % tabs.length];
          this.activateTab(tab);
          tab.focus();
        });

        this.guide.addEventListener('click', event => {
          if (event.target === this.guide) this.guide.close();
        });

        this.updateVariant(false);
        this.activateTab(this.querySelector('[role="tab"]'));
      }

      normalize(text) {
        return String(text || '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }

      indexImages() {
        const colors = this.colorIndex < 0
          ? []
          : [...new Set(
              this.data.variants.map(v => v.options[this.colorIndex])
            )];

        const orderedColors = [...colors].sort(
          (a, b) => b.length - a.length
        );

        let group = [];

        this.data.images.forEach(image => {
          const linked = this.data.variants.filter(v =>
            image.variantIds.includes(v.id) ||
            v.featured_image?.id === image.id
          );

          const anchors = this.colorIndex < 0
            ? []
            : [...new Set(linked.map(v => v.options[this.colorIndex]))];

          const tags = [...image.alt.matchAll(/\[color:([^\]]+)\]/gi)]
            .map(match => this.normalize(match[1]));

          const explicit = colors.filter(
            color => tags.includes(this.normalize(color))
          );

          const normalizedAlt = ' ' + this.normalize(image.alt) + ' ';

          const altColor = orderedColors.find(color =>
            normalizedAlt.includes(' ' + this.normalize(color) + ' ')
          );

          const identified = tags.length
            ? explicit
            : anchors.length
              ? anchors
              : altColor
                ? [altColor]
                : [];

          if (identified.length) group = identified;

          image.colors = identified.length
            ? identified
            : tags.length
              ? []
              : this.dataset.groups === 'true'
                ? [...group]
                : [];
        });
      }

      paintSwatches() {
        const palette = {
          black: '#171717',
          white: '#faf9f6',
          navy: '#202b43',
          'dark heather': '#505156',
          'sport grey': '#afafad',
          'sport gray': '#afafad',
          asphalt: '#45484b',
          charcoal: '#424548',
          'military green': '#62684d',
          natural: '#eee5d0',
          sand: '#cfbfa5',
          red: '#aa3039',
          royal: '#254a99',
          'royal blue': '#254a99',
          blue: '#4c7394',
          green: '#536f51',
          'forest green': '#284d3b',
          maroon: '#622b3a',
          purple: '#665079',
          orange: '#c87536',
          yellow: '#d2b250',
          'light blue': '#b7cedc',
          'light pink': '#e9c5d0',
          'heather navy': '#414c61',
          'dark chocolate': '#493830',
          brown: '#654c3e',
          grey: '#a2a2a0',
          gray: '#a2a2a0'
        };

        (this.data.swatches || '').split('\n').forEach(line => {
          const split = line.indexOf('=');
          if (split < 0) return;

          const color = line.slice(split + 1).trim();

          if (CSS.supports('color', color)) {
            palette[this.normalize(line.slice(0, split))] = color;
          }
        });

        this.querySelectorAll('.vp-color').forEach(button => {
          const swatch = button.querySelector('.vp-swatch');

          if (swatch.hasAttribute('data-native-swatch')) return;

          const key = this.normalize(button.dataset.value);

          const color = palette[key] ||
            (CSS.supports('color', key) ? key : null);

          if (color) {
            swatch.style.backgroundColor = color;
          } else {
            swatch.textContent = button.dataset.value
              .slice(0, 2).toUpperCase();
            swatch.style.fontSize = '9px';
            swatch.style.lineHeight = '33px';
          }
        });
      }

      onClick(event) {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;

        if (button.matches('.vp-value')) {
          const index = Number(
            button.closest('[data-option-index]').dataset.optionIndex
          );

          this.selection[index] = button.dataset.value;

          if (index === this.colorIndex) {
            const exact = this.data.variants.find(v =>
              v.options.every((value, i) => value === this.selection[i])
            );

            if (!exact?.available) {
              const candidates = this.data.variants.filter(
                v => v.options[index] === button.dataset.value
              );

              const fallback =
                candidates.find(v => v.available) ||
                exact ||
                candidates[0];

              if (fallback) this.selection = [...fallback.options];
            }
          }

          this.updateVariant(true);
        }

        if (button.hasAttribute('data-direction')) {
          this.showImage(
            this.imageIndex + Number(button.dataset.direction)
          );
        }

        if (button.hasAttribute('data-image-index')) {
          this.showImage(Number(button.dataset.imageIndex));
        }

        if (button.hasAttribute('data-quantity')) {
          const step = Number(this.quantity.step) || 1;

          this.quantity.value =
            Number(this.quantity.value || this.quantity.min) +
            Number(button.dataset.quantity) * step;

          this.normalizeQuantity();
        }

        if (button.hasAttribute('data-open-guide')) {
          this.guide.showModal();
        }

        if (button.hasAttribute('data-close-guide')) {
          this.guide.close();
        }

        if (button.getAttribute('role') === 'tab') {
          this.activateTab(button);
        }
      }

      normalizeQuantity() {
        const min = Number(this.quantity.min) || 1;
        const step = Number(this.quantity.step) || 1;
        const max = this.quantity.max
          ? Number(this.quantity.max)
          : Infinity;

        let value = Number(this.quantity.value);
        if (!Number.isFinite(value)) value = min;

        value = min +
          Math.max(0, Math.floor((value - min) / step)) * step;

        const permittedMax = Number.isFinite(max)
          ? min + Math.floor((max - min) / step) * step
          : Infinity;

        this.quantity.value = Math.max(
          min, Math.min(permittedMax, value)
        );
      }

      updateVariant(updateUrl) {
        this.variant = this.data.variants.find(v =>
          v.options.every((value, i) => value === this.selection[i])
        );

        this.querySelectorAll('[data-option-index]').forEach(fieldset => {
          const index = Number(fieldset.dataset.optionIndex);

          fieldset.querySelector('.vp-selected-value').textContent =
            this.selection[index];

          fieldset.querySelectorAll('.vp-value').forEach(button => {
            button.setAttribute(
              'aria-pressed',
              String(button.dataset.value === this.selection[index])
            );

            const available = this.data.variants.some(v =>
              v.available &&
              v.options.every((value, i) =>
                i === index
                  ? value === button.dataset.value
                  : index === this.colorIndex ||
                    value === this.selection[i]
              )
            );

            button.classList.toggle('vp-unavailable', !available);
          });
        });

        const available = Boolean(this.variant?.available);
        const add = this.querySelector('.vp-add');

        add.disabled = !available;
        add.textContent = !this.variant
          ? 'Unavailable'
          : available
            ? 'Add to cart'
            : 'Sold out';

        this.querySelector('.vp-status').textContent = !this.variant
          ? 'This combination is unavailable. Please choose another option.'
          : !available
            ? 'This variant is currently sold out.'
            : '';

        this.select.disabled = !this.variant;

        if (this.variant) {
          this.select.value = String(this.variant.id);

          const price = this.data.prices[this.variant.id];
          this.querySelector('.vp-price').textContent = price.price;

          const compare = this.querySelector('.vp-compare');
          compare.textContent = price.compare;
          compare.hidden = !(
            this.variant.compare_at_price > this.variant.price
          );

          const rule = this.variant.quantity_rule || {
            min: 1,
            increment: 1
          };

          this.quantity.min = rule.min || 1;
          this.quantity.step = rule.increment || 1;
          this.quantity.max = rule.max == null ? '' : rule.max;

          this.normalizeQuantity();
        } else {
          this.querySelector('.vp-price').textContent = '—';
          this.querySelector('.vp-compare').hidden = true;
        }

        const payment = this.querySelector('.vp-payment');
        if (payment) payment.hidden = !available;

        const color = this.colorIndex < 0
          ? ''
          : this.selection[this.colorIndex];

        if (this.galleryColor !== color || !this.visibleImages) {
          this.galleryColor = color;

          this.visibleImages = this.data.images.filter(image =>
            this.colorIndex < 0 || image.colors.includes(color)
          );

          this.buildThumbnails();

          const featured = this.visibleImages.findIndex(
            image => image.id === this.variant?.featured_image?.id
          );

          this.showImage(featured < 0 ? 0 : featured);
        }

        if (updateUrl) {
          const url = new URL(location.href);

          if (this.variant) {
            url.searchParams.set('variant', this.variant.id);
          } else {
            url.searchParams.delete('variant');
          }

          history.replaceState({}, '', url);

          this.select.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }
      }

      buildThumbnails() {
        this.thumbs.replaceChildren();
        this.track.replaceChildren();

        this.visibleImages.forEach((image, index) => {
          const slide = document.createElement('div');
          slide.className = 'vp-slide';
          slide.setAttribute('role', 'group');
          slide.setAttribute(
            'aria-label',
            'Image ' + (index + 1) + ' of ' + this.visibleImages.length
          );

          const photo = document.createElement('img');
          photo.src = image.src;
          photo.alt = image.alt
            .replace(/\[color:[^\]]+\]/gi, '').trim() ||
            this.galleryColor;

          photo.width = image.width;
          photo.height = image.height;
          photo.loading = index === 0 ? 'eager' : 'lazy';
          photo.draggable = false;

          slide.append(photo);
          this.track.append(slide);
        });

        this.visibleImages.forEach((image, index) => {
          const button = document.createElement('button');

          button.type = 'button';
          button.className = 'vp-thumb';
          button.dataset.imageIndex = index;

          button.setAttribute(
            'aria-label',
            'View image ' + (index + 1) +
              (this.galleryColor ? ' — ' + this.galleryColor : '')
          );

          const img = document.createElement('img');
          img.src = image.thumb;
          img.alt = '';
          img.width = 110;
          img.height = 110;
          img.loading = 'lazy';

          button.append(img);
          this.thumbs.append(button);
        });

        this.thumbs.hidden = this.visibleImages.length <= 1;
      }

      showImage(index) {
        const count = this.visibleImages.length;

        this.querySelector('.vp-gallery-controls').hidden = count <= 1;
        this.querySelector('.vp-no-image').hidden = count > 0;
        this.track.hidden = !count;

        if (!count) {
          this.imageIndex = 0;
          return;
        }

        const target = (index + count) % count;

        this.track.scrollTo({
          left: target * this.track.clientWidth,
          behavior: 'instant'
        });

        this.markImage(target);
      }

      markImage(index) {
        const count = this.visibleImages.length;

        this.imageIndex = Math.max(
          0, Math.min(index, count - 1)
        );

        this.querySelector('.vp-counter').textContent =
          (this.imageIndex + 1) + ' / ' + count;

        [...this.thumbs.children].forEach((button, i) => {
          button.setAttribute(
            'aria-pressed',
            String(i === this.imageIndex)
          );
        });

        const active = this.thumbs.children[this.imageIndex];

        if (active) {
          const left = active.offsetLeft - this.thumbs.offsetLeft;

          if (
            left < this.thumbs.scrollLeft ||
            left + active.offsetWidth >
              this.thumbs.scrollLeft + this.thumbs.clientWidth
          ) {
            this.thumbs.scrollLeft = left;
          }
        }
      }

      activateTab(tab) {
        this.querySelectorAll('[role="tab"]').forEach(item => {
          item.setAttribute('aria-selected', String(item === tab));
          item.tabIndex = item === tab ? 0 : -1;
        });

        this.querySelectorAll('[role="tabpanel"]').forEach(panel => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
